import { render, staticRenderFns } from "./CrearClientes.vue?vue&type=template&id=050c1608"
import script from "./CrearClientes.vue?vue&type=script&lang=js"
export * from "./CrearClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports